<template>
  <div class="wrap">
    <div class="left">
      <!--工作记录-->
      <el-table ref="tb" :data="schedules" border>
        <el-table-column label="工作类别" min-width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ $utils.meta.format("schedule-type", row.Type) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="Request"
          label="任务内容"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="Result"
          label="工作反馈"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="Operator.Name"
          label="经办人"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column label="跟进时间" min-width="140">
          <template slot-scope="{ row }">
            {{ $utils.common.parseTime(row?.ExecTime, "{y}-{m}-{d} {h}:{i}") }}
          </template>
        </el-table-column>
      </el-table>
      <!--项目成员-->
      <teams :demand="demand.Id" />
      <!--线索详情-->
      <el-descriptions border :column="2">
        <el-descriptions-item label="客户名称">
          {{ demand.Client }}
        </el-descriptions-item>
        <el-descriptions-item label="联系地址">
          {{ demand.Address }}
        </el-descriptions-item>
        <el-descriptions-item label="联系人">
          {{ demand.Linkman }}
          ({{ demand.Gender }})
        </el-descriptions-item>
        <el-descriptions-item label="部门职务">
          {{ demand.Dept }} {{ demand.Job }}
        </el-descriptions-item>
        <el-descriptions-item label="联系电话">
          {{ demand.Linktel }}
        </el-descriptions-item>
        <el-descriptions-item label="工作电话">
          {{ demand.Worktel }}
        </el-descriptions-item>
        <el-descriptions-item label="QQ、微信">
          {{ demand.QQ }}
        </el-descriptions-item>
        <el-descriptions-item label="线索来源">
          {{ $utils.meta.format("demand-from", demand.Source) }}
        </el-descriptions-item>
        <el-descriptions-item label="当前使用情况">
          <span v-if="demand.MonthlyAmount"
            >每月总印量{{ demand.MonthlyAmount }}张</span
          >
          <span v-if="demand.MonthlyFee"
            >每月消费金额{{ demand.MonthlyFee }}元</span
          >
          <span v-if="demand.YearlyAmount"
            >预估年印量{{ demand.YearlyAmount }}张</span
          >
        </el-descriptions-item>
        <el-descriptions-item label="我们占比">
          <span v-if="demand.WeAmount">印量{{ demand.WeAmount }}张</span>
          <span v-if="demand.WeFee">消费金额{{ demand.WeFee }}元</span>
        </el-descriptions-item>
        <el-descriptions-item label="预计销售金额">
          {{ demand.ProAmount }}
        </el-descriptions-item>
        <el-descriptions-item label="预计签单日期">
          {{ $utils.common.parseTime(demand?.ProDealDate) }}
        </el-descriptions-item>
        <el-descriptions-item label="需求说明">
          <p v-if="demand.NeedCopier">{{ demand.NeedCopier }}</p>
          <p v-if="demand.NeedCopier">{{ demand.NeedPrinter }}</p>
          <p v-if="demand.NeedCopier">{{ demand.NeedOther }}</p>
          <p class="text-space">{{ demand.Explain }}</p>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="right">
      <!--跟进统计-->
      <schedule_type_group
        :params="{ target: demand.Id }"
        style="background-color: #fff; padding: 20px"
      />
      <!--操作记录-->
      <records
        type="Job-Demand"
        :id="demand.Id"
        style="background: #fff; grid-row-start: span 3"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    teams: () => import("./_team.vue"),
    records: () => import("@/views/system/record/list.vue"),
    schedule_type_group: () => import("@/views/job/schedule/statis/_type.vue"),
  },
  data() {
    return {
      loading: false,
      demand: null,
      schedules: null,
      teams: null,
    };
  },
  created() {
    let id = this.$route.query?.id;
    if (id) {
      this.loadDemand(id);
      this.loadSchedule(id);
    }
  },
  methods: {
    loadDemand(id) {
      this.$apis.job.demand
        .info({
          id: id,
        })
        .then((res) => {
          if (res != null) {
            this.demand = res;
          } else {
            this.$router.go(-1);
          }
        });
    },
    loadSchedule(id) {
      this.$apis.job.schedule
        .list({
          index: 1,
          row: 5,
          target: id,
        })
        .then((res) => {
          if (res != null) {
            this.schedules = res.Items;
          } else {
            this.$router.go(-1);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 300px;
  min-height: 100%;
  .left,
  .right {
    display: grid;
    grid-gap: 10px;
  }
}
:deep(.el-descriptions) {
  &-item__label {
    min-width: 120px;
  }
  &-item__cell {
    span + span {
      margin-left: 10px;
    }
  }
}
</style>